// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.156Z

export const heroes = [
  {
    "id": "deus_kirosa",
    "name_ru": "Заместитель директора Кироса",
    "name_en": "Deputy Director Kirosa",
    "faction": "deus",
    "type": "hero",
    "rarity": "special",
    "archetype": "Танк-угонщик",
    "exclusive_hero": null,
    "atk": 0,
    "armor": 0,
    "hp": 20,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1 раз за бой: угнать вражеского юнита с атакой ≤3",
      "trigger": "В конце хода +2 Влияния если ХП Героя выше Героя врага"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "filter": "any",
      "target": "self",
      "effect": "influence_gain",
      "value": "2",
      "duration": "oneshot",
      "condition": "hp_above_enemy_hero"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "enemy_choose",
      "effect": "mind_control",
      "duration": "oneshot",
      "condition": "target_atk_le_3",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "Бывший хакер, поднявшийся через корпоративные интриги. Контролирует чужие руки.",
    "ability_text_en": {
      "active": "Once per match: steal an enemy unit with attack ≤3",
      "trigger": "At the end of the turn, +2 Influence if the Hero's hp is higher than the enemy Hero's"
    }
  },
  {
    "id": "deus_nikosi",
    "name_ru": "Старший оперативник Никоси",
    "name_en": "Senior Operative Nikosi",
    "faction": "deus",
    "type": "hero",
    "rarity": "special",
    "archetype": "Агро Героем",
    "exclusive_hero": null,
    "atk": 2,
    "armor": 1,
    "hp": 11,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1 раз за бой: урон по выбранному вражескому юниту = текущему Влиянию (через Авангард как обычная атака)",
      "trigger": "+1 Влияния за каждую атаку Героем"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "hero_attack",
      "filter": "self",
      "target": "self",
      "effect": "influence_gain",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "enemy_choose",
      "effect": "damage",
      "value": "current_influence",
      "duration": "oneshot",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "Полевой агент с импланом-катаной. Лично работает в спорных ситуациях.",
    "ability_text_en": {
      "active": "Once per match: damage to a chosen enemy unit equal to current Influence (through Taunt, like a normal attack)",
      "trigger": "+1 Influence for each Hero attack"
    }
  },
  {
    "id": "deus_sina",
    "name_ru": "Руководитель внедрения Сина",
    "name_en": "Head of Implementation Sina",
    "faction": "deus",
    "type": "hero",
    "rarity": "special",
    "archetype": "Sacrifice",
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 12,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1 раз за бой: уничтожь своего юнита. Нанеси Герою врага урон = его атаке",
      "trigger": "+1 Влияния за каждую смерть своего юнита"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "any",
      "target": "self",
      "effect": "influence_gain",
      "value": "1",
      "duration": "oneshot"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "ally_choose",
      "effect": "destroy_self_then_damage_hero",
      "value": "target_atk",
      "duration": "oneshot",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "Куратор тёмных операций. «Каждая жертва — инвестиция в победу».",
    "ability_text_en": {
      "active": "Once per match: destroy one of your units. Deal damage to the enemy Hero equal to its attack",
      "trigger": "+1 Influence for each of your units that dies"
    }
  },
  {
    "id": "deus_tanaki",
    "name_ru": "Генеральный директор Танаки",
    "name_en": "CEO Tanaki",
    "faction": "deus",
    "type": "hero",
    "rarity": "special",
    "archetype": "Магнат",
    "exclusive_hero": null,
    "atk": 1,
    "armor": 2,
    "hp": 8,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1 раз за бой: +4 Влияния.",
      "trigger": "В Фазе 1 каждого хода (со 2-го) +1 Влияния"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "filter": "any",
      "target": "self",
      "effect": "influence_gain",
      "value": "1",
      "duration": "oneshot",
      "condition": "turn_number_ge_2"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "self",
      "effect": "influence_gain",
      "value": "4",
      "duration": "oneshot",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "Древний токиоский клан, поднявшийся на корпоративных слияниях. Не воюет — нанимает воюющих.",
    "ability_text_en": {
      "active": "Once per match: +4 Influence.",
      "trigger": "In Phase 1 of each turn (from the 2nd on), +1 Influence"
    }
  }
];
